import { enUS, es, ro } from "date-fns/locale";

export const getDateFnsIntlObject = (locale: string) => {
  if (locale === "en") {
    return enUS;
  }
  if (locale === "es") {
    return es;
  }
  return ro;
};
